import { createContext } from 'react';
import { AFProviderValue } from './Provider';

const Context = createContext<AFProviderValue>({ listStep: [], flowInfo: null, actions: null, loadingFlow: false });

export default Context;
